// react-markdown's defaultUrlTransform strips `tel:` (and most non-HTTP schemes), producing
// `href=""` and breaking the dialer. Allow the schemes we actually use; reject anything else so
// `javascript:` and `data:` can never slip through.
const ALLOWED_SCHEME = /^(?:https?|mailto|tel|sms):/i;
// The path, query or fragment opens before any colon, so that colon is data rather than a scheme
// separator: `docs/a:b` and `#a:b` are relative URLs, not a `docs/a:` scheme.
const RELATIVE_BEFORE_COLON = /^[^:]*[/?#]/;

/** react-markdown `urlTransform` that keeps our allowed schemes intact and blanks the rest. */
export function markdownUrlTransform(href: string): string {
  if (ALLOWED_SCHEME.test(href)) return href;
  // Any other colon is a scheme we don't allow — decided without matching the scheme's *shape*.
  // Browsers strip tabs and newlines inside a URL, so `java<TAB>script:` has to be rejected, and a
  // `^[a-z][a-z\d+.-]*:` test finds no scheme there and would wave it through. Platform's
  // `normalizeHref` uses that shape safely only because its fallback prefixes `https://`; this one
  // passes the href along, so it cannot.
  return RELATIVE_BEFORE_COLON.test(href) || !href.includes(':') ? href : '';
}

/** A link the device handles directly — `tel:`/`mailto:`/`sms:` — which must reach a native anchor
 *  for the dialer/mail client to fire. Everything else (web, relative, hash, query) routes through
 *  the app's navigation so baseUrl resolution, iframe nav, and analytics still apply. */
export function isDeviceHandlerLink(href: string | undefined): boolean {
  if (!href) return false;
  return /^(?:tel|mailto|sms):/i.test(href);
}
